export const SHIFT_START_8_MS = 8 * 60 * 60 * 1000; // 28800000
export const SHIFT_END_18_MS = 18 * 60 * 60 * 1000; // 64800000

export const WORKING_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri'];
